import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  loginService,
  logoutService,
} from "../../../services/auth/auth.service";
import { getUserFromToken, isTokenExpired } from "../../../utils/jwt";
import Cookies from "js-cookie";

export const loginThunk = createAsyncThunk(
  "auth/login",
  async (credentials, { rejectWithValue }) => {
    try {
      return await loginService(credentials);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Credenciales inválidas";
      //   alert(message);
      return rejectWithValue(message);
    }
  },
);
const tokenFromCookie = Cookies.get("access_token");

const isValidToken = tokenFromCookie && !isTokenExpired(tokenFromCookie);

const initialState = {
  user: isValidToken ? getUserFromToken(tokenFromCookie) : null,
  accessToken: isValidToken ? tokenFromCookie : null,
  loading: false,
  error: null,
  isAuthenticated: isValidToken,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      logoutService();
      state.user = null;
      state.accessToken = null;
      state.isAuthenticated = false;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(loginThunk.fulfilled, (state, action) => {
        const { access } = action.payload;

        state.loading = false;
        state.accessToken = access;
        state.user = getUserFromToken(access);
        state.isAuthenticated = true;
        state.error = null;
      })
      .addCase(loginThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logout, clearError } = authSlice.actions;
export default authSlice.reducer;
